export default __webpack_public_path__ + "static/media/dashboard-2.ce62694a.png";